import t, { useState as r, useEffect as e } from "react";
import { AppLauncherPanel as n } from "./AppLauncherPanel.js";
import { componentName as a } from "../../../utils/bem/index.js";
import { tip as o } from "../../forms/Tooltip/Tooltip.js";
import "../../../../node_modules/classnames/index.js";
import { t as i } from "../../../i18/index.js";
import { isTokenValid as c } from "../../../utils/jwt/index.js";
import l from "../../../css/img/app-launcher-white.svg.js";
function p(t, r) {
  (null == r || r > t.length) && (r = t.length);
  for (var e = 0, n = Array(r); e < r; e++) n[e] = t[e];
  return n;
}
function u(t, r) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, r) {
    var e,
      n,
      a = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null != a) {
      var o = [],
        i = !0,
        c = !1;
      try {
        for (a = a.call(t); !(i = (e = a.next()).done) && (o.push(e.value), !r || o.length !== r); i = !0);
      } catch (t) {
        c = !0, n = t;
      } finally {
        try {
          i || null == a.return || a.return();
        } finally {
          if (c) throw n;
        }
      }
      return o;
    }
  }(t, r) || function (t, r) {
    if (t) {
      if ("string" == typeof t) return p(t, r);
      var e = Object.prototype.toString.call(t).slice(8, -1);
      if ("Object" === e && t.constructor && (e = t.constructor.name), "Map" === e || "Set" === e) return Array.from(e);
      if ("Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return p(t, r);
    }
  }(t, r) || function () {
    throw TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var s = {
  PRODUCTION: "https://api.launcher.kaseya.com",
  QA: "https://qa.api.launcher.kaseya.com"
};
function m(p) {
  var m = p.k1Token,
    f = p.apps,
    h = p.useQaLauncherApi,
    d = p.cacheKey,
    y = p.launcherApiVersion,
    v = void 0 === y ? 1 : y,
    g = u(r(!1), 2),
    A = g[0],
    b = g[1],
    j = u(r(f || null), 2),
    I = j[0],
    N = j[1],
    S = h ? s.QA : s.PRODUCTION;
  e(function () {
    var t,
      r = d && (null === (t = JSON.parse(localStorage.getItem(d) || null)) || void 0 === t ? void 0 : t.appsData);
    m && c(m) ? fetch("".concat(S, "/api/v").concat(v, "/launcher/products"), {
      method: "get",
      headers: {
        Authorization: "Bearer ".concat(m)
      }
    }).then(function (t) {
      return t.json();
    }).then(function (t) {
      N(t), localStorage.setItem(d, JSON.stringify({
        appsData: t
      }));
    }).catch(function () {
      r && N(r);
    }) : r && N(r);
  }, [m]), e(function () {
    o({
      className: "kaseya-ui-itc-app-launcher__tooltip",
      target: ".app-launcher__icon-wrapper",
      content: i("topbar.app-launcher"),
      options: {
        position: "bottom"
      }
    });
  }, []);
  var _ = function _() {
    b(!A);
  };
  return t.createElement("div", {
    className: a("itc-app-launcher")
  }, t.createElement("div", {
    className: "app-launcher__icon-wrapper"
  }, t.createElement("img", {
    className: "app-launcher__icon",
    src: l,
    onClick: _
  })), A && t.createElement(n, {
    apps: I,
    onClose: _
  }));
}
m.displayName = "ITCAppLauncher";
export { m as ITCAppLauncher, s as appLauncherApiUrl };